module.exports = __webpack_public_path__ + "media/1_Long.add9edbf.mp3";